import { render, staticRenderFns } from "./VTSpriteLoader.vue?vue&type=template&id=61874c26&"
import script from "./VTSpriteLoader.vue?vue&type=script&lang=js&"
export * from "./VTSpriteLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports